import React, { useRef, useState, useEffect } from "react";

import { addCommasToNum } from "../utils";

import { useQuery } from "react-query";
import { getMostWatchedEventsByRange } from "../actions";

import { useDraggable } from "react-use-draggable-scroll";

import { Typography, Box, Card, CardContent, Skeleton } from "@mui/material";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const EventCard = ({ title, imageSrc, plays, date }) => {
  return (
    <Card
      sx={{
        position: "relative",
        marginRight: "20px",
        minWidth: "270px",
        lineHeight: 2,
        height: "300px",
        color: "#fff",

        background: `linear-gradient(to top, rgba(0, 0, 0, 0.65) 35%, transparent 100%), url(${imageSrc})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",

        transition: "transform 450ms",
        "&:hover": {
          transform: "scale(1.08)",
        },
      }}
    >
      <CardContent
        sx={{
          position: "absolute",
          bottom: 0,
        }}
      >
        <Typography gutterBottom variant="h4">
          {title}
        </Typography>

        <Typography variant="subtitle1">
          {addCommasToNum(plays, 3, 0)} plays
          {date && (
            <span
              style={{
                margin: "0 4px",
              }}
            >
              •
            </span>
          )}
          {date}
        </Typography>
      </CardContent>
    </Card>
  );
};

const MostWatched = ({ clientID, startDate, endDate }) => {
  const cardContainerRef = useRef(null);
  const { events: draggableEvents } = useDraggable(cardContainerRef);

  const {
    isLoading,
    data: mostWatchedEvents,
    refetch,
  } = useQuery({
    queryKey: `mostWatchedEvents`,
    queryFn: () =>
      getMostWatchedEventsByRange({ clientID, startDate, endDate }),
    placeholderData: [],
  });

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    refetch();
  }, [startDate, endDate]);

  return (
    <>
      <Typography variant="h3" sx={{ mb: 2 }}>
        {isLoading ? <Skeleton width={60} variant="text" /> : "Most Watched"}
      </Typography>

      {isLoading ? (
        <Skeleton
          ref={cardContainerRef}
          width="100%"
          height={400}
          sx={{ mt: -10 }}
        />
      ) : (
        <Box
          {...draggableEvents}
          ref={cardContainerRef}
          sx={{
            display: "flex",

            overflowY: "hidden",
            overflowX: "scroll",
            padding: "20px",

            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          {mostWatchedEvents.length > 0 ? (
            mostWatchedEvents.map((event) => (
              <Link
                key={event.eventID}
                to={`/events/?eventID=${event.eventID}`}
              >
                <EventCard
                  title={event.title}
                  plays={event.plays}
                  imageSrc={event.image}
                  date={format(new Date(event.startDateTime), "MMM d, YYYY")}
                />
              </Link>
            ))
          ) : (
            <Card
              sx={{
                position: "relative",
                minWidth: "270px",
                lineHeight: 2,
                height: "300px",
                color: "#fff",

                background: `linear-gradient(to top, rgba(0, 0, 0, 0.4) 15%, transparent 100%)`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <CardContent
                sx={{
                  position: "absolute",
                  bottom: 0,
                }}
              >
                <Typography variant="h4">No Events to Display</Typography>
                <Link to="/events">Create an Event</Link>
              </CardContent>
            </Card>
          )}
        </Box>
      )}
    </>
  );
};

export default MostWatched;
